import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api`;

// Product Services
export const productService = {
  getAllProducts: async (category = null, search = null, limit = null) => {
    try {
      const params = {};
      if (category && category !== 'all') params.category = category;
      if (search) params.search = search;
      if (limit) params.limit = limit;
      
      const response = await axios.get(`${API_URL}/products`, { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching products:', error);
      throw error;
    }
  },

  searchProducts: async (query) => {
    try {
      const response = await axios.get(`${API_URL}/products`, { 
        params: { search: query } 
      });
      return response.data;
    } catch (error) {
      console.error('Error searching products:', error);
      throw error;
    }
  },

  getProductByCode: async (productCode) => {
    try {
      const response = await axios.get(`${API_URL}/products/${productCode}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching product:', error);
      throw error;
    }
  },

  getProductCount: async (category = null) => {
    try {
      const params = {};
      if (category && category !== 'all') params.category = category;
      
      const response = await axios.get(`${API_URL}/products/count`, { params });
      return response.data.count;
    } catch (error) {
      console.error('Error fetching product count:', error);
      return 0;
    }
  }
};

// Category Services
export const categoryService = {
  getAllCategories: async () => {
    try {
      const response = await axios.get(`${API_URL}/categories`);
      return response.data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      throw error;
    }
  },
  
  getCategoryHierarchy: async () => {
    try {
      const response = await axios.get(`${API_URL}/categories/hierarchy`);
      return response.data;
    } catch (error) {
      console.error('Error fetching category hierarchy:', error);
      throw error;
    }
  }
};

// Quote Services
export const quoteService = {
  submitQuote: async (quoteData) => {
    try {
      const response = await axios.post(`${API_URL}/quotes`, quoteData);
      return response.data;
    } catch (error) {
      console.error('Error submitting quote:', error);
      throw error;
    }
  }
};

// Contact Services
export const contactService = {
  submitContact: async (contactData) => {
    try {
      const response = await axios.post(`${API_URL}/contact`, contactData);
      return response.data;
    } catch (error) {
      console.error('Error submitting contact:', error);
      throw error;
    }
  }
};
